/* eslint-disable */
import { Eye, EyeOff } from 'lucide-react';

const Legend = (props) => {
    const {
        list,
        setIsLegend,
        isClickable = false,
        selectedLegend = null,
        multiSelect = false
    } = props;

    const isItemActive = (value) => {
        if (multiSelect) {
            return Array.isArray(selectedLegend) && selectedLegend.includes(value);
        }
        return selectedLegend === value;
    };

    const handleSetSelected = (value) => {
        if (!isClickable) return;

        if (multiSelect) {
            const currentSelected = Array.isArray(selectedLegend) ? selectedLegend : [];
            let newSelected;
            if (currentSelected.includes(value)) {
                newSelected = currentSelected.filter(v => v !== value);
            } else {
                newSelected = [...currentSelected, value];
            }
            setIsLegend(newSelected.length > 0 ? newSelected : null);
        } else {
            const newValue = selectedLegend === value ? null : value;
            setIsLegend(newValue);
        }
    };

    return (
        <div
            className='absolute top-[2.5rem] left-0 bg-white shadow-lg rounded-md p-2.5 z-[1000] w-[320px] max-h-[60vh] overflow-y-auto border border-gray-200'
            onClick={(e) => e.stopPropagation()}
        >
            <div className='text-xs text-gray-400 mb-2 font-medium'>
                Legend {multiSelect && <span>(Multi-select)</span>}
            </div>
            {/* Compact 2-column grid taaki lambi list height na le. */}
            <div className='grid grid-cols-2 gap-x-3 gap-y-1'>
                {list?.map((item) => {
                    const isActive = isItemActive(item?.value);
                    return (
                        <div
                            key={item?.value}
                            onClick={() => handleSetSelected(item?.value)}
                            title={item?.label}
                            className={`flex items-center justify-between gap-1.5 rounded-md px-1.5 py-1 hover:bg-gray-50 ${isClickable ? 'cursor-pointer' : ''} ${isActive ? 'bg-gray-100' : ''}`}>
                            <div className={`flex items-center gap-1.5 min-w-0 ${isActive ? 'text-gray-500' : ''}`}>
                                {item?.img
                                    ? <img src={item?.img} alt={item?.label} className='w-4 h-4 shrink-0' />
                                    : <span className='shrink-0 [&>*]:w-4 [&>*]:h-4'>{item?.icon}</span>}
                                <span className='text-[12px] font-medium truncate'>{item?.label}</span>
                            </div>
                            {item?.showEye && (
                                isActive
                                    ? <EyeOff size={14} className='text-gray-400 shrink-0' />
                                    : <Eye size={14} className='shrink-0' />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Legend;
